<!-- Footer Content -->
<footer class="footer py-3 my-4" style="background-color: #f8f9fa; border-top: 1px solid #dee2e6;">
  <div class="container">
    <div class="row">
      <div class="col-md-6 mb-4 mb-lg-0" style="padding-top: 20px;">
        <div class="row">
          <div class="col-md-3" style="text-align: center;">
            <img class="img img-responsive" ngSrc="assets/images/kapi1.png" width="150" height="89" alt="İstanbul Üniversitesi Logo" style="vertical-align: super; max-width: 150px;" />
          </div>
          <div class="col-md-9">
            <p class="m-0">{{ 'FOOTER_DESCRIPTION' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-6" style="padding-top: 20px;">
        <div class="row">
          <div class="col-md-12">
            <ul class="list list-icons list-icons-lg">
              <li><i class="far fa-dot-circle text-color-primary"></i><p class="m-0">Istanbul Universitesi Rektorlugu <br/>34452 Beyazıt / Fatih / Istanbul</p></li>
              <li><i class="fab fa-whatsapp text-color-primary"></i><p class="m-0"><a href="tel:+902124400000">+90 212 440 00 00</a></p></li>
              <li><i class="far fa-envelope text-color-primary"></i><p class="m-0"><a href="mailto:iupress@istanbul.edu.tr" target="_blank">iupress&#64;istanbul.edu.tr</a></p></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-12 text-center">
        <p>&copy; {{ currentYear }} İstanbul Üniversitesi Yayınevi. Tüm hakları saklıdır.</p>
      </div>
    </div>
  </div>
  <style>
    footer i {
      color: #bdbdbd !important;
    }
    footer .list-icons i {
      width: 25px;
      text-align: center;
      margin-right: 10px;
    }
    footer .list-icons p {
      display: inline-block;
    }
    footer hr {
      margin: 20px 0;
    }
  </style>
</footer>